import {
  PriceListCreateDerivedRequestType,
  PriceListCreateDerivedResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceListCreateDerived = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PriceListCreateDerivedRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `price-lists/derive`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as PriceListCreateDerivedResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
    },
  });
};
